export const constants = {
  API: "https://transfer.oeilabsolu.ch/api",
  max_files: 250,
  max_size: 25 * Math.pow(2, 30) + 1,
  oa_mail: "info@oeilabsolu.ch",
};
